import StateMachine from 'javascript-state-machine';

const fsmMakePick = new StateMachine({
  transitions: [
    { name: 'set', from: '*', to(state) { return state; } },
  ],
});

export default fsmMakePick;
